import React, { useCallback } from "react";
import Button from "../../framework/Button";

const DownloadData = ({
  id = "",
  selectedBranch = "",
  selectedColumns = [],
  exportFileName = "Export CSV",
  exportButtonLabel = "Export CSV",
  data = [],
  disabled = false,
  onSuccess = () => {},
  color = "black",
}) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const modifiedData = useCallback(
    (dt) => {
      return dt.map((item) => {
        if (item?.branchMetaData && item?.branchMetaData[selectedBranch]) {
          const branchData = item?.branchMetaData[selectedBranch];
          const keysToModify = Object.keys(branchData);
          const hasKeysToModify = selectedColumns.some((col) =>
            keysToModify.includes(col)
          );

          if (hasKeysToModify) {
            keysToModify.forEach((key) => {
              if (
                selectedColumns.includes(key) &&
                branchData[key] !== undefined
              ) {
                item[key] = branchData[key];
              }
            });
          }
        }
        return item;
      });
    },
    [selectedBranch, selectedColumns]
  );

  const exportToCSV = async () => {
    if (!data.length) {
      return;
    }
    const _data = modifiedData(data);
    const filteredData = _data.map((item) => {
      const filteredItem = {};
      selectedColumns.forEach((col) => {
        filteredItem[col] = item[col];
      });
      return filteredItem;
    });

    const csvContent = [selectedColumns.join(",")]
      .concat(
        filteredData.map((item) => {
          return selectedColumns.map((col) => item[col] ?? "").join(",");
        })
      )
      .join("\n");

    const blob = new Blob([csvContent], { type: fileType });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${exportFileName}.csv`;
    link.click();

    onSuccess();
  };

  return (
    <Button
      id={id}
      label={exportButtonLabel}
      onClick={exportToCSV}
      disabled={disabled}
      color={color}
    />
  );
};

export default DownloadData;
